var _defs, _rect, _polygon, _polygon2, _path, _path2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerelictHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.59 84.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#94979b;}.cls-2{fill:#d0cfcf;}.cls-3{fill:#c94746;}.cls-4{fill:#e84c5c;}.cls-5{fill:#3e4347;}.cls-6{fill:#dbb471;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 79.3,
    width: 84.59,
    height: 5.29
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.15 19.82 58.15 79.3 80.62 79.3 75.33 48.9 80.62 19.82 58.15 19.82"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "66.08 21.15 34.36 5.29 7.93 31.72 11.89 42.29 6.61 79.3 64.76 79.3 59.48 62.12 66.08 21.15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.32,19.08,50.22,0H34.36L66.08,23.79H81.94a2.62,2.62,0,0,0,2.31-1.26A2.53,2.53,0,0,0,83.32,19.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.46,19.08,34.36,0,1.26,34.94a2.52,2.52,0,0,0,2.53,4.37l30.57-34L64.93,23.45a2.52,2.52,0,1,0,2.53-4.37Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64.76 58.15 69.3 79.3 75.33 79.3 64.76 58.15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "72.69 51.55 67.41 68.83 70.16 72.69 72.69 51.55"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.13 52.87 31.72 52.87 29.08 67.41 31.72 79.3 18.13 79.3 15.86 62.12 18.13 52.87"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.57 42.29 67.41 42.29 69.17 31.72 75.33 31.72 73.57 42.29"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "31.72 42.29 21.15 42.29 18.5 31.72 29.08 31.72 31.72 42.29"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "39.65 42.29 50.22 42.29 52.87 31.72 42.29 31.72 39.65 42.29"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "55.51 47.58 50.22 42.29 52.87 31.72 58.15 37.01 55.51 47.58"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.07 3.96 53.07 6.74 50.22 6.74 58.76 11.94 63.03 11.94 68.73 14.54 64.46 9.25 59.48 9.25 53.07 3.96"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54.19 71.37 41.21 71.37 38.33 62.12 41.21 52.87 54.19 52.87 52.63 60.58 54.19 71.37"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "14.77 74.01 13.22 70.5 32.81 66.08 34.36 69.59 14.77 74.01"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "33.69 64.76 13.22 60.92 13.89 56.83 34.36 60.67 33.69 64.76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerelictHouse);
export default __webpack_public_path__ + "static/media/derelict_house.ae8e7a9afddd3d333990392ca5075ce0.svg";
export { ForwardRef as ReactComponent };